import { render, staticRenderFns } from "./UserCardHomePanelNotAffiliated.vue?vue&type=template&id=6f6e844a&scoped=true"
import script from "./UserCardHomePanelNotAffiliated.vue?vue&type=script&lang=js"
export * from "./UserCardHomePanelNotAffiliated.vue?vue&type=script&lang=js"
import style0 from "./UserCardHomePanelNotAffiliated.vue?vue&type=style&index=0&id=6f6e844a&prod&lang=css"
import style1 from "./UserCardHomePanelNotAffiliated.vue?vue&type=style&index=1&id=6f6e844a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e844a",
  null
  
)

export default component.exports